import { useContext, useEffect, useState } from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { ROUTE_SETTINGS_ENTITY } from 'routes/RouteList';
import { FormattedMessage } from 'react-intl';
import Breadcrumbs from 'components/breadcrumbs/Breadcrumbs';
import Breadcrumb from 'components/breadcrumbs/Breadcrumb';
import Card from 'components/card/Card';
import { QUERY_GET_ORGANISATION_BY_ID } from 'services/aws/entity-query';
import messages from 'messages';
import OrganisationFormInput from 'containers/pages/settings/organisations/OrganisationFormInput';
import OrganisationSettings from 'containers/pages/settings/organisations/OrganisationSettings';
import FormEditFooterButtons from 'containers/partials/buttons/FormEditFooterButtons';
import OrganisationForm from 'containers/pages/settings/organisations/OrganisationForm';
import { StoreContext } from 'index';
import OrganisationEntity from 'models/Organisation';
import { useQuery } from '@apollo/client';
import useEdit from 'hooks/utils/useEdit';
import {
  Panel,
  PanelBody,
  PanelHeader,
  PanelSubtitle,
  PanelTitle,
  PanelTitleWrapper
} from 'components/panel';
import Loader from 'components/loader/Loader';

const GlobalSettings = ({ ...props }) => {
  const { push } = useHistory();
  const {
    authStore: { user }
  } = useContext(StoreContext);
  const { entityId } = useParams();
  const [edit, setEdit] = useEdit(props.edit, true);
  const [organisation, setOrganisation] = useState(
    new OrganisationEntity({ baseLanguage: user.baseLanguage })
  );

  const { data, loading } = useQuery(QUERY_GET_ORGANISATION_BY_ID, {
    variables: { id: entityId },
    skip: !entityId
  });

  useEffect(() => {
    if (data?.getEntity) {
      setOrganisation(new OrganisationEntity(data.getEntity));
    }
  }, [data]);
  return (
    <Panel style={{ boxShadow: '0 0 10px -8px black' }}>
      <PanelHeader borderBottom>
        <Breadcrumbs>
          <Breadcrumb
            onClick={() =>
              push(generatePath(ROUTE_SETTINGS_ENTITY, { entityId }))
            }
          >
            <FormattedMessage {...messages.breadcrumbSettings} />
          </Breadcrumb>
        </Breadcrumbs>
        <PanelTitleWrapper>
          <PanelTitle>{organisation.name}</PanelTitle>
          <PanelSubtitle>
            <FormattedMessage {...messages.subtitleGlobalSettings} />
          </PanelSubtitle>
        </PanelTitleWrapper>
      </PanelHeader>
      <PanelBody>
        {loading && <Loader />}
        <OrganisationForm
          organisationId={entityId}
          organisation={organisation}
          onComplete={() => setEdit(false)}
          allowFeatureEdit={edit && user.superadmin}
        >
          {({ submitForm, isValid, isSubmitting, resetForm }) => (
            <Card secondary multiBody>
              <OrganisationFormInput organisation={organisation} edit={edit} />
              <OrganisationSettings
                edit={edit && user.superadmin}
                organisation={organisation}
              />
              <FormEditFooterButtons
                edit={edit}
                setEdit={setEdit}
                onCancel={() => {
                  resetForm();
                }}
                onSubmit={submitForm}
                disabledSubmit={!isValid || isSubmitting}
                topMargin
                extraClassNames={'c-card__footer-bottom-fixed'}
              />
            </Card>
          )}
        </OrganisationForm>
      </PanelBody>
    </Panel>
  );
};

export default GlobalSettings;
